import React from 'react';

const AppReleaseNoticesFormModal = React.lazy(() => import('../components/FormModal'));
const appReleaseNoticesModalRegistry = {
    core_appReleaseNoticesId: AppReleaseNoticesFormModal
};
export default appReleaseNoticesModalRegistry;
